<div
        mat-dialog-title
        class="dialog-header justify-content-between"
>

    <h3 class="dialog-header-text">
        <ng-content select="[dialog-title]"></ng-content>
    </h3>
    <button
            class="close"
            *ngIf="!config.disabledCloseBtn"
            mat-icon-button
            mat-dialog-close
            tabindex="-1"
    ><i
            class="icon-cancel"
            aria-hidden="true"
    ></i></button>
    <button
            class="back"
            *ngIf="!config.disabledCloseBtn"
            mat-icon-button
            mat-dialog-close
            tabindex="-1"
    ><i
            class="icon-chevron-left"
            aria-hidden="true"
    ></i><div>{{ 'CREATE_ORDER.BACK' | translate }}</div></button>
</div>

<div
        mat-dialog-content
>
    <ng-container *ngIf="!config.process.finished; else dialogProcessFinished">
        <ng-container *ngIf="!config.process.loading; else loaderContainer">
            <ng-content select="[dialog-process-in-progress]"></ng-content>
        </ng-container>
        <ng-template #loaderContainer>
            <div class="preloader-wrapper">
                <app-preloader></app-preloader>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #dialogProcessFinished>
        <div class="mb-4 d-flex justify-content-center">
            <ng-container *ngIf="!config.process.failed; else failedProcessContainer">
                <i class="fa fa-2x fa-check-circle text-accent d-flex align-items-center"></i>
                <span
                        class="ml-2 text-justify"
                        [innerHTML]="config.process.succeedMessage|sanitizeHtml"
                ></span>
            </ng-container>
            <ng-template #failedProcessContainer>
                <i class="fa fa-2x fa-times-circle text-danger d-flex align-items-center"></i>
                <span
                        class="ml-2 text-justify"
                        [innerHTML]="config.process.failedMessage|sanitizeHtml"
                ></span>
            </ng-template>
        </div>
        <div class="row justify-content-center">
            <button
                    class="btn btn-primary"
                    (click)="sendActionCode(actionsEnum.ProcessFinished)"
            >Ok</button>
        </div>
    </ng-template>
</div>

<div
        *ngIf="config && (config.buttons.length > 0) && !config.buttonsHidden"
        mat-dialog-actions
        class="justify-content-end mt-3"
>
    <ng-container *ngFor="let button of config.buttons">
        <ng-container [ngSwitch]="button.type">
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Cancel"
                    (click)="sendActionCode(actionsEnum.Decline, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-dialog-close
                    color="primary-light"
                    class="me-2"
            >{{!button.customText ? 'Cancel' : (button.customText | translate)}}
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Delete"
                    (click)="sendActionCode(actionsEnum.Decline, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="danger"
                    class="me-2"
            >Delete
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Remove"
                    (click)="sendActionCode(actionsEnum.Decline, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="warning"
                    class="me-2"
            >Remove
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Ok"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >Ok
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Submit"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >Submit
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Apply"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >Apply
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Create"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >Create
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Save"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >Save
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Confirm"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >{{!button.customText ? 'Confirm' : (button.customText | translate)}}
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Update"
                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >Update
            </button>
            <button
                    type="button"
                    *ngSwitchCase="buttonTypesEnum.Back"
                    (click)="sendActionCode(actionsEnum.Decline, button.disabled)"
                    [disabled]="button.disabled || config.buttonsDisabled"
                    mat-button
                    mat-stroked-button
                    mat-raised-button
                    color="primary"
                    class="me-2"
            >
                <i
                        class="icon-arrowback"
                        aria-hidden="true"
                ></i>
            </button>
        </ng-container>
    </ng-container>
</div>